import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import {PublicInterceptor} from '../../../Base/interceptors/PublicInterceptor';

// get oganigrama camden
export const getOrganigramaCamden = async() => {
    const result = await PublicInterceptor('Camden', 'GET')
    return result;
}

export const getOrganigramaPublicCamden = async (Id) => {
    const result = await PublicInterceptor(`Camden/PublicOrganigrama`, 'POST', {Id});
    return result;
}

export const getInfoOrganigramaCamden = async(token) => {

    const result = await PublicInterceptor('Camden/getCamden', 'GET', {},token)
    return result;
}

